import { SupportedLanguages } from '../../i18n/constants';

import type { Country } from './types';

export const FALLBACK_COUNTRY_CODE = 'US';

export const FALLBACK_COUNTRY: Country = {
  code: '',
  name: 'Unknown Country',
  subdivisionName: 'Region',
  postalCodeName: 'Postal Code',
  isActive: false,
  cookieConsentEnabled: false,
  usercentricsSettingsId: '',
  defaultLanguage: SupportedLanguages.EN,
};
